const actions = {
  SET_STATE: 'coordinator/SET_STATE',
  PROFILE_UPDATE: 'coordinator/PROFILE_UPDATE',
  PASSWORD_UPDATE: 'coordinator/PASSWORD_UPDATE',
  REFRESH_ERRORS: 'coordinator/REFRESH_ERRORS',
  FETCH_ALL: 'coordinator/FETCH_ALL',
  DETAILS: 'coordinator/DETAILS',
  ADD: 'coordinator/ADD',
  EDIT: 'coordinator/EDIT'
};

export default actions
